import React from 'react';

import { LoginComponent } from '../components';

export function LoginPage() {
  return <LoginComponent />;
}
